export var source = "fragment GqlError on DisplayableGQLError {\n  error\n  message\n  timestamp\n  additionalFields\n}";
export default source;